import { gql } from '@apollo/client';

export const GET_MATERIALS = gql`
  query getMaterials($ids: [ID!]!) {
    workPackagesByIds(ids: $ids) {
      id
      materials {
        tagOrStockCode
        iso
        design
        issue
        balance
        mwrs {
          mwrNumber
          mwrStatus
        }
        onHand
        description
      }
    }
  }
`;
